<template lang="pug">
  .crud(v-if="has_permission")
    modal-quotation-files(:newRecord='newRecord', :is-add='isModalAdd' :project="project_id")
    vm-row.separador-quote-file(vm-w="12")
      vm-col(vm-lg=6 vm-sm=6)
        router-link(:to="project.status === 1 ? {name: 'quotes'} : {name: 'inOrders'}")
          vm-button(icon="arrow-back-outline" radius)
    .container-general
      span.title  {{ $t('strings.add') }}
      span.title-color  {{ $t('projects.quotations') }}
      br
      button-line-dot(v-if="$auth.check('Admin')" text=" add Quotation" @click="addQuotationFile")
      vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          file-card(v-if="project.miscellaneous_file && quotation_files_index_permission" :data="cano" showDelete :showSee="false" @view="openViewer(project.miscellaneous_file)"  @attachment="deleteQuotationConfirm")
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          file-card(v-if="project.job_file && quotation_files_index_permission" :data="job" showDelete :showSee="false" @view="openViewer(project.job_file)"  @attachment="deleteQuotationConfirm")
        vm-col(vm-justify="center", vm-align="center", vm-w=4)
          file-card(v-if="project.client_file && quotation_files_index_permission" :data="steel" showDelete :showSee="false" @view="openViewer(project.client_file)"  @attachment="deleteQuotationConfirm")
        span.table-title(v-if="project.miscellaneous_file && quotation_files_index_permission") Structure, Miscellaneous, Mounting, Sheet
        vm-table(v-if="project.miscellaneous_file && quotation_files_index_permission" :data="canoList" style="width: 100%")
          template(slot="header")
            .d-flex.justify-content-between
              div
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns" :style="index === 0 ? 'width: 60%' : ''") {{ $t('projects.' + column) }}
            vm-th
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'subtotal' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column != 'status'") {{data[indextr][column]}}
              vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], tr)")
                      vm-icon(icon="eye-outline")
                      slot &nbsp;{{ $t('strings.view') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="download(data[indextr], tr)")
                      vm-icon(icon="arrow-downward-outline")
                      slot &nbsp;{{ $t('strings.download') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteQuotationConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
        span.table-title(v-if="project.job_file && quotation_files_index_permission") Job
        vm-table(v-if="project.job_file && quotation_files_index_permission" :data="jobList" style="width: 100%")
          template(slot="header")
            .d-flex.justify-content-between
              div
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns" :style="index === 0 ? 'width: 60%' : ''") {{ $t('projects.' + column) }}
            vm-th
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'subtotal' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column != 'status'") {{data[indextr][column]}}
              vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], tr)")
                      vm-icon(icon="eye-outline")
                      slot &nbsp;{{ $t('strings.view') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="download(data[indextr], tr)")
                      vm-icon(icon="arrow-downward-outline")
                      slot &nbsp;{{ $t('strings.download') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteQuotationConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
        span.table-title(v-if="project.client_file && quotation_files_index_permission") Quotation Cano Steel To Client
        vm-table(v-if="project.client_file && quotation_files_index_permission" :data="steelList" style="width: 100%")
          template(slot="header")
            .d-flex.justify-content-between
              div
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns" :style="index === 0 ? 'width: 60%' : ''") {{ $t('projects.' + column) }}
            vm-th
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'subtotal' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column != 'status'") {{data[indextr][column]}}
              vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], tr)")
                      vm-icon(icon="eye-outline")
                      slot &nbsp;{{ $t('strings.view') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="download(data[indextr], tr)")
                      vm-icon(icon="arrow-downward-outline")
                      slot &nbsp;{{ $t('strings.download') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="deleteQuotationConfirm(data[indextr])")
                      vm-icon(icon="trash-2-outline")
                      slot &nbsp;{{ $t('strings.delete') }}
</template>

<script>
import ModalQuotationFiles from '@/components/modals/ModalQuotationFiles.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('QuotationFiles')

export default {
  name: 'QuotationFiles',
  components: {
    ModalQuotationFiles,
    ButtonLineDot: () => import('@/components/aditionals/ButtonLineDot.vue'),
    FileCard: () => import('@/components/aditionals/FileCard.vue')
  },
  data: () => ({
    isModalAdd: true,
    project_id: null,
    has_permission: true,
    quotation_files_store_permission: true,
    quotation_files_index_permission: true,
    customer_comments_quotation: true,
    customer: true,
    newRecord: {},
    columns: [
      'filename',
      'comments',
      'date'
    ]
  }),
  async created () {
    this.checkPermissionView('quoteds.index')
    this.$route.params.id && (await this.getQuotationFiles())
  },
  methods: {
    ...mapActions([
      'loadQuotationFiles',
      'setModalVisible',
      'deleteQuotation'
    ]),
    addQuotationFile () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
      this.project_id = this.$route.params.id
    },
    async getQuotationFiles () {
      let t = this
      this.loadQuotationFiles(this.$route.params).then(data => t.getProps(t.$route.params.id))
    },
    openViewer (record) {
      this.$viewer.show({
        urlFile: record.file_url,
        mime: 'application/pdf',
        name: record.filename,
        color: '#FFF'
      })
    },
    download (record) {
      window.open(record.file_url, '_blank')
    },
    deleteQuotationConfirm (quotation) {
      let t = this
      this.auxDeleteQuotation = () => {
        t.deleteQuotation(quotation).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quotation'), attribute: this.$t(quotation.id) }),
        accept: this.auxDeleteQuotation
      })
    },
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.quotation_files_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotation_files.store') > -1
      this.quotation_files_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotation_files.index') > -1
      this.customer_comments_quotation = this.$auth.user().view_permissions.findIndex(e => e.name === 'customer_comments_quotation.store') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    }
  },
  computed: {
    ...mapGetters([
      'project',
      'pagination'
    ]),
    cano () {
      return {
        filename: 'Structure, Miscellaneous, Mounting, Sheet',
        mime_type: 'application/pdf',
        date: this.project.miscellaneous_file.date ? this.project.miscellaneous_file.date : '',
        file_url: this.project.miscellaneous_file.file_url ? this.project.miscellaneous_file.file_url : '',
        id: this.project.miscellaneous_file.id ? this.project.miscellaneous_file.id : null,
        comments: this.project.miscellaneous_file.comments ? this.project.miscellaneous_file.comments : ''
      }
    },
    job () {
      return {
        filename: 'Job',
        mime_type: 'application/pdf',
        date: this.project.job_file.date ? this.project.job_file.date : '',
        file_url: this.project.job_file.file_url ? this.project.job_file.file_url : '',
        id: this.project.job_file.id ? this.project.job_file.id : null,
        comments: this.project.job_file.comments ? this.project.job_file.comments : ''
      }
    },
    steel () {
      return {
        filename: 'Quotation Cano Steel To Client',
        mime_type: 'application/pdf',
        date: this.project.client_file.date ? this.project.client_file.date : '',
        file_url: this.project.client_file.file_url ? this.project.client_file.file_url : '',
        id: this.project.client_file.id ? this.project.client_file.id : null,
        comments: this.project.client_file.comments ? this.project.client_file.comments : ''
      }
    },
    canoList () {
      return this.project.quotations_files.filter(files => files.type === 1)
    },
    jobList () {
      return this.project.quotations_files.filter(files => files.type === 2)
    },
    steelList () {
      return this.project.quotations_files.filter(files => files.type === 3)
    }
  }
}
</script>

<style lang="css" scoped>
.container-general {
  background: white;
  padding: 30px 35px;
  border-radius: 15px;
  min-height: 300px;
  margin: 50px;
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
}
.title {
  font-weight: bold;
  font-size: 20px;
}
.title-color {
  font-weight: bold;
   font-size: 20px;
  color: rgba(var(--primary), 1);
}
.table-title {
  margin: 30px 10px 0px 30px;
  font-weight: bold;
  color: rgba(var(--primary), 1);
  padding: 10px 5px;
  border-bottom: 1.5px solid rgb(192, 192, 192);
  width: 100%;
}
.separador-quote-file {
  padding: 20px 0px 0px 50px;
}
</style>
